var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckcirclegris(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.651,
    height: 10.674,
    viewBox: "0 0 14.651 10.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c3cfd6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M125.293,169.466l-9.107,9.034a.606.606,0,0,1-.856,0L111,174.128a.606.606,0,0,1,0-.856l.43-.426a.606.606,0,0,1,.856,0l3.48,3.509,8.247-8.181a.605.605,0,0,1,.856,0l.426.43A.605.605,0,0,1,125.293,169.466Z",
    transform: "translate(-110.821 -168)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcirclegris);
export default __webpack_public_path__ + "static/media/checkcirclegris.c3eb33c539b493512ca245a70f9f7416.svg";
export { ForwardRef as ReactComponent };